import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CollapsibleNavTooltipProps {
  collapsed: boolean;
  content: ReactNode;
  children: ReactNode;
}

export function CollapsibleNavTooltip({ collapsed, content, children }: CollapsibleNavTooltipProps) {
  if (!collapsed) {
    return <>{children}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right">{content}</TooltipContent>
    </Tooltip>
  );
}
